$(document).ready(() => {

    $('#owlcompare-nb').text(owlcompare.nbProducts);

    $('body').on('click', '.js-owlcompare-add', function (event) {
        let self = this;
        prestashop.emit('clickOwlCompareAdd', {
            dataset: self.dataset,
            self: self
        });
        event.preventDefault();
    });

    $('body').on('click', '.js-owlcompare-remove', function (event) {

        let self = this;
        prestashop.emit('clickOwlCompareRemove', {
            dataset: self.dataset
        });
        event.preventDefault();
    });

    $('body').on('click', '.js-owlcompare-remove-all', function (event) {

        let self = this;
        prestashop.emit('clickOwlCompareRemoveAll', {
            dataset: self.dataset
        });
        event.preventDefault();
    });

    prestashop.on('clickOwlCompareAdd', function (elm) {

        let data = {
            'process': 'add',
            'ajax': 1,
            'idProduct': elm.dataset.idProduct,
        };

        $.post(elm.dataset.url, data, null, 'json').then(function (resp) {

            if (resp.success){
                owlcompare.nbProducts++;
                $('#owlcompare-nb').text(owlcompare.nbProducts);
            }

            $(elm.self).addClass('owlcompare-added');

            let $notification =  $('#owlcompare-notification');
            $notification.addClass('ns-show');

            setTimeout(function(){
                $notification.removeClass('ns-show');
            }, 3500);


        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'clickOwlCompareAdd', resp: resp});
        });

    });

    prestashop.on('clickOwlCompareRemove', function (elm) {

        let data = {
            'process': 'remove',
            'ajax': 1,
            'idProduct': elm.dataset.idProduct,
        };

        $.post(elm.dataset.url, data, null, 'json').then(function (resp) {
            $('.js-owlcompare-product-' + elm.dataset.idProduct).remove();
            owlcompare.nbProducts--;
            $('#owlcompare-nb').text(owlcompare.nbProducts);

            if (owlcompare.nbProducts == 0) {
                $('#owlcompare-table').remove();
                $('#owlcompare-warning').removeClass('hidden-xs-up');
            }

        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'clickOwlCompareRemove', resp: resp});
        });

    });

    prestashop.on('clickOwlCompareRemoveAll', function (elm) {

        let data = {
            'process': 'removeAll',
            'ajax': 1,
        };

        $.post(elm.dataset.url, data, null, 'json').then(function (resp) {

            $('#owlcompare-nb').text(0);
            $('#owlcompare-table').remove();
            $('#owlcompare-warning').removeClass('hidden-xs-up');

        }).fail((resp) => {
            prestashop.emit('handleError', {eventType: 'clickOwlCompareRemove', resp: resp});
        });

    });


});





// WEBPACK FOOTER //
// ./front/front.js